export default __webpack_public_path__ + "fonts/poppins-v9-latin-600.woff";